// Formatierung. Alles Deutsch, an einer Stelle — damit nicht an der einen
// Ansicht "1200 €" und an der anderen "1.200,00 EUR" steht.

const euroGanz = new Intl.NumberFormat("de-DE", {
  style: "currency", currency: "EUR", maximumFractionDigits: 0,
});
const euroGenau = new Intl.NumberFormat("de-DE", {
  style: "currency", currency: "EUR", minimumFractionDigits: 2,
});
const prozent = new Intl.NumberFormat("de-DE", {
  style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1,
});

const zahl = (wert: unknown): number => {
  const n = Number(wert);
  return Number.isFinite(n) ? n : 0;
};

/** Gerundet, für Kennzahlen und Summen. */
export const eur = (wert: unknown): string => euroGanz.format(zahl(wert));

/** Auf den Cent, für Mieten und Kautionen. */
export const eur2 = (wert: unknown): string => euroGenau.format(zahl(wert));

/** null heißt "nicht berechenbar" und wird als Strich gezeigt, nicht als 0 %. */
export const pct = (wert: number | null | undefined): string =>
  wert === null || wert === undefined || !Number.isFinite(wert) ? "–" : prozent.format(wert);

export const datum = (wert: string | null | undefined): string => {
  if (!wert) return "–";
  const d = new Date(wert);
  return Number.isNaN(d.getTime()) ? "–" : d.toLocaleDateString("de-DE");
};

export const uhrzeit = (wert: Date): string =>
  wert.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });

/** Für Datumsfelder im Formular: yyyy-mm-dd oder leer. */
export const alsFeldDatum = (wert: string | null | undefined): string =>
  wert ? String(wert).slice(0, 10) : "";

export const heute = (): string => new Date().toISOString().slice(0, 10);

/** "1 Objekt" / "3 Objekte" — spart überall den Ternär. */
export const anzahl = (n: number, einzahl: string, mehrzahl: string): string =>
  `${n} ${n === 1 ? einzahl : mehrzahl}`;

export const dateigroesse = (bytes: number): string =>
  bytes < 1024 ? `${bytes} B`
    : bytes < 1024 * 1024 ? `${Math.round(bytes / 1024)} kB`
      : `${(bytes / 1024 / 1024).toFixed(1)} MB`;
